import { render, staticRenderFns } from "./ListSortir.vue?vue&type=template&id=52acd9bd&scoped=true"
import script from "./ListSortir.vue?vue&type=script&lang=js"
export * from "./ListSortir.vue?vue&type=script&lang=js"
import style0 from "./ListSortir.vue?vue&type=style&index=0&id=52acd9bd&prod&scoped=true&lang=css"
import style1 from "./ListSortir.vue?vue&type=style&index=1&id=52acd9bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52acd9bd",
  null
  
)

export default component.exports